export class StorageUtils {
  public static getCustomerId(): string | null {
    return localStorage.getItem('selectedCustomer');
  }

  public static setCustomerId(id: string) {
    localStorage.setItem('selectedCustomer', id);
  }

  public static getCustomerName(): string | null {
    return localStorage.getItem('selectedCustomerName');
  }

  public static setCustomerName(name: string) {
    localStorage.setItem('selectedCustomerName', name);
  }

  public static getPlatformId(): string | null {
    return localStorage.getItem('selectedPlatform');
  }

  public static setPlatformId(id: string) {
    localStorage.setItem('selectedPlatform', id);
  }
}
